import { render, staticRenderFns } from "./sdkTerms.vue?vue&type=template&id=f8f52a56"
import script from "./sdkTerms.vue?vue&type=script&lang=js"
export * from "./sdkTerms.vue?vue&type=script&lang=js"
import style0 from "./sdkTerms.vue?vue&type=style&index=0&id=f8f52a56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports